import React, { useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import '../../agrari-styles/sidenav.css'
import { PrivateComponent } from '../PrivateComponent'
import { Icon } from "semantic-ui-react";
import AppInfo from '../AppInfo';
import logo from '../../agrari-styles/logo 1v.png';

function EpicMenu() {
    const [menuAbierto, cambiarMenuAbierto] = useState(false)
    const history = useHistory();

    const toggleMenu =()=> {
        cambiarMenuAbierto(abierto => !abierto)
    }
    const handleLogout = () => {
        // Redirect to the login page
        history.push('/logout');
    }
    return (
        <div className='inline'>
            <button
                className={`fillsidenav ${menuAbierto ? 'fillsidenav--visible' : ''}`}
                onClick={toggleMenu}
                aria-label="Cerrar menú"
                tabIndex={menuAbierto ? 0 : -1}
            />
            <button className="mainMenu menuTrigger" onClick={toggleMenu} aria-label="Abrir menú principal">
                <Icon name='sidebar' />
            </button>
            <nav id="mySidenav" className={`sidenav ${menuAbierto ? 'sidenav--open' : ''}`} aria-hidden={!menuAbierto}>
                <div className="sidenavHeader">
                    <img src={logo} alt="Agrari" />
                    <div>
                        <span>Menú principal</span>
                    </div>
                </div>
                <button className="mainMenu closebtn" onClick={toggleMenu} aria-label="Cerrar menú principal">
                    <Icon name='window close outline' />
                </button>
            
                <ul className="menu-list">
                    <li className = "menu-list-item">
                        <NavLink exact activeClassName="menu-link--active" className="menu-link" to="/perfil" onClick={toggleMenu}>
                            <Icon name='user' />Perfil
                        </NavLink>
                    </li>
                    <PrivateComponent roles={['farmAdmin']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Pendientes" onClick={toggleMenu}>
                                <Icon name='tasks' />Pendientes
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles={['farmAdmin']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Asignados" onClick={toggleMenu}>
                                <Icon name='tasks' />Asignados
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles ={['farmAdmin']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Asistencia" onClick={toggleMenu}>
                                <Icon name='clock outline' />Asistencia
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles ={['farmAdmin']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Actividades" onClick={toggleMenu}>
                                <Icon name='th list' />Actividades
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles ={['farmAdmin']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Calendario" onClick={toggleMenu}>
                                <Icon name='calendar alternate' />Calendario
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles={['farmAdmin']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/pisca" onClick={toggleMenu}>
                                <Icon name='inbox' />Pisca
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles={['farmAdmin']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Zonas" onClick={toggleMenu}>
                                <Icon name='th' />Zonas
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles={['office']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Pagos" onClick={toggleMenu}>
                                <Icon name='dollar sign' />Pagos
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles={['office']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Empleados" onClick={toggleMenu}>
                                <Icon name='address card outline' />Empleados
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles ={['office']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Documentos" onClick={toggleMenu}>
                                <Icon name='th list' />Documentos
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Herramientas" onClick={toggleMenu}>
                                <Icon name='archive' />Herramientas
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Productos" onClick={toggleMenu}>
                                <Icon name='archive' />Productos
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <PrivateComponent roles={['admin']}>
                        <li className="menu-list-item">
                            <NavLink activeClassName="menu-link--active" className="menu-link" to="/Ajustes" onClick={toggleMenu}>
                                <Icon name='cog' />Ajustes
                            </NavLink>
                        </li>
                    </PrivateComponent>
                    <li className = "menu-list-item">
                        <button className="menuLogout" onClick={handleLogout}>
                            <Icon name='log out' />Salir
                        </button>
                    </li>
                    <PrivateComponent roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin', 'office']}>
                        <li className = "menu-list-item">
                            <AppInfo />
                        </li>
                    </PrivateComponent>
                </ul>
            </nav>
        </div>
    )
}

export default EpicMenu;
